import dayjs from 'dayjs';
import { formatEmployeeThaiName } from '../../../utils/functions/employeeName';

export const FUEL_TYPES = ['เบนซิน', 'ดีเซล', 'ไฮบริด', 'EV'];

export const FUEL_COLOR = { เบนซิน: 'warning', ดีเซล: 'default', ไฮบริด: 'success', EV: 'info' };

export const COMPANY_NAME = 'Sotus Engineering';

export const emptyVehicle = {
  license_plate: '',
  brand: '',
  model_name: '',
  fuel_type: 'เบนซิน',
  rate_per_km: 4,
  is_default: false,
  initial_mileage: 0,
  owner_type: 'personal',
  owner_employee: null,
  owner_name: '',
  owner_reason: '',
};

export const emptyFuelClaim = {
  vehicle: null,
  date: dayjs().format('YYYY-MM-DD'),
  payment_date: dayjs().add(1, 'day').format('YYYY-MM-DD'),
  odo_in: '',
  fuel_amount: '',
  bill_image: null,
  odo_image: null,
  project: null,
  budget: null,
  expenses_type: 'REFUND',
  invoice_number: '',
  customer: null,
  payee: { name: '', bank: '', account_number: '' },
  other_images: [],
  fuel_liters: '',
  fuel_price_per_liter: '',
  fuel_station: '',
  vat_amount: '',
  base_amount: '',
  fuel_license_plate_in_bill: '',
  fuel_type_in_bill: '',
};

export function ownerLabel(v, employees) {
  if (v.owner_type === 'company') return COMPANY_NAME;
  if (v.owner_type === 'other') return v.owner_name || 'อื่นๆ';
  const emp = employees?.find((e) => e._id === (v.owner_employee?._id || v.owner_employee));
  return emp ? formatEmployeeThaiName(emp) : '-';
}
